/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChevronDownUp = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M16.793 3.293 12 8.086 7.207 3.293 5.793 4.707 12 10.914l6.207-6.207-1.414-1.414zm0 17.414L12 15.914l-4.793 4.793-1.414-1.414L12 13.086l6.207 6.207-1.414 1.414z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgChevronDownUp as ChevronDownUp };
